import React from 'react';

import ExtendedNavLink from '../../components/ExtendedNavLink';
import {linkToMarketing} from '../../lib/url/linkToMarketing';
import {useTypography} from '../../styles';

type NavItem = {
  text: string;
  url: string;
};

export const navItems: NavItem[] = [
  {text: 'About alliz', url: linkToMarketing('/about')},
  {text: 'Events', url: linkToMarketing('/event')},
  {text: 'Our Community', url: linkToMarketing('/community')},
  {text: 'FAQs', url: linkToMarketing('/faq')},
];

const useNavLinks = () => {
  const {link} = useTypography();

  return navItems.map(({text, url}, index) => {
    return (
      <ExtendedNavLink
        css={link}
        key={index}
        to={url}
      >
        {text}
      </ExtendedNavLink>
    );
  });
};

export default useNavLinks;
